import * as React from 'react'

import Routing from './routing'
import Keep100vh from './Resizer'

import './styles/base.scss'

const App = () => (
  <Keep100vh>
    <Routing />
  </Keep100vh>
)

export default App
